import React, { useMemo } from "react";

import useSWRWrapper, { ChildrenFunction, Fetcher } from "../../hooks/useSWRWrapper";
import { PaginatedResponse, Product } from "../../interfaces";

interface Props {
  id: number;
  excludeIngredientGroups?: number[];
  excludeOtherIngredients?: string[];
  filterSupplementForms?: string[];
  filterBrands?: string[];
  page?: number;
  pageSize?: number;
}

export const useIngredientGroupProductList = (props: Props) => {
  const {
    id,
    excludeOtherIngredients,
    excludeIngredientGroups,
    filterSupplementForms,
    filterBrands,
    page,
    pageSize,
  } = props;
  const queryString = useMemo(() => {
    const params = new URLSearchParams();

    if (excludeIngredientGroups && excludeIngredientGroups.length > 0) {
      params.set("-ingredientGroups", excludeIngredientGroups.join(","));
    }

    if (excludeOtherIngredients && excludeOtherIngredients.length > 0) {
      params.set("-otherIngredients", excludeOtherIngredients.join(","));
    }

    if (filterSupplementForms && filterSupplementForms.length > 0) {
      params.set("supplementForms", filterSupplementForms.join(","));
    }

    if (filterBrands && filterBrands.length > 0) {
      params.set("brands", filterBrands.join(","));
    }

    if (page) {
      params.set("page", page.toString());
    }

    if (pageSize) {
      params.set("pageSize", pageSize.toString());
    }

    return params.toString();
  }, [excludeIngredientGroups, excludeOtherIngredients, page, pageSize]);
  return useSWRWrapper<PaginatedResponse<Product>, Error>(
    `/api/ingredient_groups/${id}/products?${queryString}`,
    Fetcher({
      method: "GET",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    })
  );
};

const IngredientGroupProductList: React.FC<Props> = (props) => {
  const { children, ...rest } = props;
  const response = useIngredientGroupProductList(rest);

  return (children as ChildrenFunction<PaginatedResponse<Product>, Error>)(response);
};

export default IngredientGroupProductList;
